@if (isLoading) {
  <div class="xi-loader-container__center">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<ng-container *transloco="let t">
  <div class="widget-container">
    @if (hasTaxonomyLevel) {
      <div class="taxonomy-level">
        <xi-default-button
          class="taxonomy-search-button"
          fill="outline"
          [text]="t('widgets.search')"
          iconLeft="search"
          buttonSize="small"
          (onClick)="searchTaxonomy()"
        ></xi-default-button>
        <span class="taxonomy-location">{{ displayTaxonomyPath }}</span>
      </div>
    }

    <div
      class="context-menu-trigger-container"
      [class.hide]="isShowAsDataTable || noData || isDataSourceNotFound || hasInvalidComparison"
    >
      <div class="chart-sort-container--y"></div>

      <div #elementContent class="content" [class.hide]="isLoading"></div>

      @if (!dashboard.locked) {
        <div
          [matMenuTriggerFor]="widgetContextMenuTrigger"
          #contextMenuTriggerElement="matMenuTrigger"
          class="context-menu-trigger"
        ></div>
      }
      @if (dashboard.locked) {
        <div
          [matMenuTriggerFor]="lockedWidgetContextMenuTrigger"
          #contextMenuTriggerElement="matMenuTrigger"
          class="context-menu-trigger"
        ></div>
      }
      <div class="chart-sort-container--x"></div>
    </div>

    @if (isDataSourceNotFound) {
      <div class="text-center">
        <h1>{{ t('widgets.data-source-removed-select-another') }}</h1>
      </div>
    } @else {
      @if (hasInvalidComparison) {
        <div class="text-center">
          <h1>{{ t('widgets.has-invalid-comparison') }}</h1>
        </div>
      } @else {
        @if (noDocuments || noData) {
          <div class="text-center">
            <h1>
              @if (noDocuments) {
                {{ t('widgets.no-documents-found') }}
              } @else {
                {{ t('widgets.no-data-found') }}
              }
            </h1>
            @if (isDrilledDown && !topicPhraseCloud) {
              <div>
                <xi-default-button
                  class="no-data-back-button"
                  fill="outline"
                  [text]="t('widgets.go-back-from-drill-down')"
                  iconLeft="arrow_left"
                  buttonSize="small"
                  (onClick)="drilldownInto('none', false)"
                ></xi-default-button>
              </div>
            }
            @if (isZoomedIn) {
              <div class="widget-taxonomy-map__reset-zoom">
                <xi-default-button
                  fill="outline"
                  [text]="t('widgets.reset-zoom')"
                  iconLeft="remove_circle"
                  buttonSize="small"
                  (onClick)="resetZoom()"
                ></xi-default-button>
              </div>
            }
          </div>
        }
      }
    }
    @if (isShowAsDataTable) {
      <div class="content data_table" [ngClass]="{ hide: noData || isDataSourceNotFound }">
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>{{ t('widgets.datatable.name') }}</th>
            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
          </ng-container>
          <ng-container matColumnDef="count">
            <th mat-header-cell *matHeaderCellDef>{{ t('widgets.datatable.count') }}</th>
            <td mat-cell *matCellDef="let element">{{ element.count | number }}</td>
          </ng-container>
          @if (widget.payload.drilledDownOn !== 'taxonomy_themes') {
            <ng-container matColumnDef="sentiment">
              <th mat-header-cell *matHeaderCellDef>{{ t('widgets.datatable.sentiment') }}</th>
              <td mat-cell *matCellDef="let element">{{ element.sentiment | number: '.2' }}</td>
            </ng-container>
          }
          <ng-container matColumnDef="negative">
            <th mat-header-cell *matHeaderCellDef>{{ t('widgets.datatable.negative') }}</th>
            <td mat-cell *matCellDef="let element">{{ element.negative | number }}</td>
          </ng-container>
          <ng-container matColumnDef="neutral">
            <th mat-header-cell *matHeaderCellDef>{{ t('widgets.datatable.neutral') }}</th>
            <td mat-cell *matCellDef="let element">{{ element.neutral | number }}</td>
          </ng-container>
          <ng-container matColumnDef="positive">
            <th mat-header-cell *matHeaderCellDef>{{ t('widgets.datatable.positive') }}</th>
            <td mat-cell *matCellDef="let element">{{ element.positive | number }}</td>
          </ng-container>
          <ng-container matColumnDef="very_negative">
            <th mat-header-cell *matHeaderCellDef>{{ t('widgets.datatable.very-negative') }}</th>
            <td mat-cell *matCellDef="let element">{{ element.very_negative | number }}</td>
          </ng-container>
          <ng-container matColumnDef="somewhat_negative">
            <th mat-header-cell *matHeaderCellDef>
              {{ t('widgets.datatable.somewhat-negative') }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.somewhat_negative | number }}</td>
          </ng-container>
          <ng-container matColumnDef="somewhat_positive">
            <th mat-header-cell *matHeaderCellDef>
              {{ t('widgets.datatable.somewhat-positive') }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.somewhat_positive | number }}</td>
          </ng-container>
          <ng-container matColumnDef="very_positive">
            <th mat-header-cell *matHeaderCellDef>{{ t('widgets.datatable.very-positive') }}</th>
            <td mat-cell *matCellDef="let element">{{ element.very_positive | number }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    }
  </div>

  <ng-template #parentFilterMenu>
    @if (isFilterGroupParent && pointName !== undefined) {
      @if (!pointSelected && filterGroupFilterDrilledDownCheck) {
        <button
          mat-menu-item
          [disabled]="!hasDocFilterGroups"
          (click)="addDocFilterGroupBluePill()"
        >
          <xi-icon icon="filter"></xi-icon>
          <div>{{ t('widgets.set-as-parent-filter') }}</div>
        </button>
      }
      @if (pointSelected) {
        <button
          mat-menu-item
          [disabled]="!hasDocFilterGroups"
          (click)="removeDocFilterGroupBluePill()"
        >
          <xi-icon icon="filter"></xi-icon>
          <div>{{ t('widgets.unset-parent-filter') }}</div>
        </button>
      }
    }
  </ng-template>

  <ng-template #widgetContextMenuPointName>
    @if (pointName) {
      <div mat-menu-item class="mat-menu-header" disabled>
        {{ pointDisplayName || pointName }}
      </div>
    }
  </ng-template>

  <mat-menu #lockedWidgetContextMenuTrigger="matMenu" class="menu-with-xi-icons">
    <ng-template [ngTemplateOutlet]="widgetContextMenuPointName"></ng-template>
    <ng-template [ngTemplateOutlet]="widgetContextMenuDrillDownBack"></ng-template>
    <ng-template [ngTemplateOutlet]="parentFilterMenu"></ng-template>
    <ng-template [ngTemplateOutlet]="widgetContextMenuDrillDown"></ng-template>
  </mat-menu>

  <ng-template #widgetContextMenuDrillDown>
    @if (
      pointName &&
      canDrilldownTaxonomy &&
      drilledDownOn !== 'mentions' &&
      drilledDownOn !== 'taxonomy_mentions' &&
      drilledDownOn !== 'taxonomy_phrases' &&
      drilledDownOn !== 'taxonomy_themes'
    ) {
      <button mat-menu-item (click)="drilldownInto('taxonomy', true)">
        <xi-icon icon="visibility"></xi-icon>
        <div>{{ t('widgets.drill-down') }}</div>
      </button>
    }

    <div [matTooltip]="showMentionsToolTip()">
      @if (pointName && canDrilldownTaxonomyMentionsAndPhrasesAndThemes) {
        <button
          mat-menu-item
          (click)="drilldownInto('taxonomy_mentions', true)"
          [disabled]="!hasMentions()"
        >
          <xi-icon [color]="!hasMentions() ? 'disabled' : 'orca'" icon="visibility"></xi-icon>
          <div>{{ t('widgets.show-mentions-of-node') }}</div>
        </button>
      }
    </div>

    <div [matTooltip]="showTopicPhrasesTooltip()">
      @if (pointName && canDrilldownTaxonomyMentionsAndPhrasesAndThemes) {
        <button
          mat-menu-item
          (click)="drilldownInto('taxonomy_phrases', true)"
          [disabled]="!hasTopicPhrases()"
        >
          <xi-icon [color]="!hasTopicPhrases() ? 'disabled' : 'orca'" icon="visibility"></xi-icon>
          <div>{{ t('widgets.show-phrases-of-node') }}</div>
        </button>
      }
    </div>

    <div [matTooltip]="showTaxonomyThemesTooltip()">
      @if (pointName && canDrilldownTaxonomyMentionsAndPhrasesAndThemes) {
        <button
          mat-menu-item
          (click)="drilldownInto('taxonomy_themes', true)"
          [disabled]="!hasTopicThemes()"
        >
          <xi-icon [color]="!hasTopicThemes() ? 'disabled' : 'orca'" icon="visibility"></xi-icon>
          <div>{{ t('widgets.show-themes-of-node') }}</div>
        </button>
      }
    </div>
  </ng-template>

  <ng-template #widgetContextMenuDrillDownBack>
    @if (isDrilledDown && backToRoot) {
      <button mat-menu-item (click)="goBackToRoot()">
        <xi-icon icon="arrow_left"></xi-icon>
        <div>{{ t('widgets.go-back-to-root') }}</div>
      </button>
    }
    @if (isDrilledDown && !topicPhraseCloud) {
      <button mat-menu-item (click)="drilldownInto('none', false)">
        <xi-icon icon="arrow_left"></xi-icon>
        <div>{{ t('widgets.go-back-from-drill-down') }}</div>
      </button>
    }
  </ng-template>

  <mat-menu #widgetContextMenuTrigger="matMenu" class="menu-with-xi-icons">
    <ng-template [ngTemplateOutlet]="widgetContextMenuPointName"></ng-template>

    <ng-template [ngTemplateOutlet]="widgetContextMenuDrillDownBack"></ng-template>

    @if (!isFilterGroupParent && filterGroupFilterDrilledDownCheck) {
      <button
        mat-menu-item
        [disabled]="!hasDocFilterGroups"
        (click)="showAddToWidgetGroupModal = true"
      >
        <xi-icon icon="filter"></xi-icon>
        <div>{{ t('widgets.add-to-widget-group') }}</div>
      </button>
    }

    <ng-template [ngTemplateOutlet]="parentFilterMenu"></ng-template>

    @if (pointName) {
      <button mat-menu-item [disabled]="!canShowDocuments" (click)="showDocumentsForItem()">
        <xi-icon [color]="!canShowDocuments ? 'disabled' : 'orca'" icon="preview"></xi-icon>
        <div>{{ t('widgets.show-documents') }}</div>
      </button>
    }
    @if (isSmartSummaryEnabled && !isReadOnly) {
      <div [matTooltip]="interactiveSmartSummaryMenu.tooltip">
        <button
          mat-menu-item
          (click)="openSmartSummary()"
          [disabled]="!interactiveSmartSummaryMenu.enabled"
        >
          <xi-icon
            [color]="!interactiveSmartSummaryMenu.enabled ? 'disabled' : 'orca'"
            icon="lightbulb"
          ></xi-icon>
          <div>{{ interactiveSmartSummaryMenu.label }}</div>
        </button>
      </div>
    }
    @if (isSmartSummaryEnabled && !isReadOnly && pointSummaries?.length > 0) {
      <div [matTooltip]="removeInteractiveSmartSummaryMenu.tooltip">
        <button
          mat-menu-item
          (click)="removeSmartSummary()"
          [disabled]="!removeInteractiveSmartSummaryMenu.enabled"
        >
          <xi-icon
            [color]="!removeInteractiveSmartSummaryMenu.enabled ? 'disabled' : 'orca'"
            icon="indeterminate"
          ></xi-icon>
          <div>{{ removeInteractiveSmartSummaryMenu.label }}</div>
        </button>
      </div>
    }
    @if (isSmartSummaryEnabled && !isReadOnly) {
      <div [matTooltip]="downloadSmartSummaryRequestToolTip">
        <button
          mat-menu-item
          (click)="downloadSmartSummarySpotERequest()"
          [disabled]="downloadingSpoteRequest || !canCreateSmartSummary"
        >
          <xi-icon
            [color]="downloadingSpoteRequest || !canCreateSmartSummary ? 'disabled' : 'orca'"
            icon="download"
          ></xi-icon>
          <div>{{ t('widgets.smart-summary.download-smart-summary-spote-request') }}</div>
        </button>
      </div>
    }
    @if (canAddComment) {
      <div [matTooltip]="commentDialogTooltip()">
        <button
          mat-menu-item
          [disabled]="!canOpenCommentDialog"
          [matMenuTriggerFor]="commentsMenuTrigger"
        >
          <xi-icon [color]="!canOpenCommentDialog ? 'disabled' : 'orca'" icon="comment"></xi-icon>
          <div>{{ t('widgets.comments.comments') }}</div>
        </button>
        <mat-menu #commentsMenuTrigger class="menu-with-xi-icons">
          <div [matTooltip]="addCommentDialogToolTip()">
            <button mat-menu-item [disabled]="isReadOnly" (click)="openCommentDialog(point)">
              <xi-icon icon="add_circle"></xi-icon>
              <div>{{ t('widgets.comments.label-add') }}</div>
            </button>
          </div>
          <div [matTooltip]="openCommentDialogToolTip(point)">
            <button
              mat-menu-item
              [disabled]="!hasComment(point)"
              (click)="onCommentListOpenClicked(point)"
            >
              <xi-icon icon="app_explore"></xi-icon>
              <div>{{ t('widgets.comments.label-open') }}</div>
            </button>
          </div>
        </mat-menu>
      </div>
    }

    <ng-template [ngTemplateOutlet]="widgetContextMenuDrillDown"></ng-template>
  </mat-menu>

  @if (showAddToWidgetGroupModal) {
    <app-lex-xi-modal
      [isVisible]="showAddToWidgetGroupModal"
      maxWidth="720px"
      (close)="onAddFiltersToWidgetGroup(undefined)"
    >
      <ng-template appXIModalContent>
        @if (showAddToWidgetGroupModal) {
          <app-add-to-widget-group-dialog
            [dashboardViewComponent]="dashboardViewComponent"
            [widget]="widget"
            (modalClosed)="onAddFiltersToWidgetGroup($event)"
          ></app-add-to-widget-group-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
  @if (showDocumentViewModal) {
    <app-lex-xi-modal
      [isVisible]="showDocumentViewModal"
      [canBackdropClose]="false"
      maxWidth="80vw"
      (close)="onDocumentViewModalClosed($event)"
    >
      <ng-template appXIModalContent>
        @if (showDocumentViewModal) {
          <app-document-view-dialog
            [options]="documentViewModalOptions"
            (modalClosed)="onDocumentViewModalClosed($event)"
          ></app-document-view-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
  @if (showSmartSummaryModal) {
    <app-lex-xi-modal
      [isVisible]="showSmartSummaryModal"
      [canBackdropClose]="false"
      maxWidth="80vw"
      (close)="onSmartSummaryClosed($event)"
    >
      <ng-template appXIModalContent>
        @if (showSmartSummaryModal) {
          <app-interactive-smart-summary
            [options]="interactiveSmartSummaryOptions"
            (modalClosed)="onSmartSummaryClosed($event)"
            (addComment)="onAddSmartSummaryComment($event)"
            (addNotes)="onAddSmartSummaryNotes($event)"
          ></app-interactive-smart-summary>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
</ng-container>
